import { __awaiter } from "tslib";
import FormValidationUtil from '../../util/FormValidationUtil';
import CustomerApi from '../../api/customer/CustomerApi';
import { AuthStatusCode, EmailValidationResponseStatus, } from '@as-react/common-types';
import { debouncedPromise } from '@as-react/common-utils';
export const EMAIL_VALIDATION_DEBOUNCE = 250;
export const validateEmailWithBackend = (email, context, servicesEndpoint, emailStatus, setSuggestedEmail, setEmailStatus) => __awaiter(void 0, void 0, void 0, function* () {
    if (emailStatus === `${EmailValidationResponseStatus.SUGGESTION}_${email}`) {
        return context.createError({ message: `${EmailValidationResponseStatus.SUGGESTION}_${email}` });
    }
    if (emailStatus === `${EmailValidationResponseStatus.VALID}_${email}`) {
        return true;
    }
    if (emailStatus === `${EmailValidationResponseStatus.INVALID_CONDITIONALLY}_${email}`) {
        return context.createError({ message: `${EmailValidationResponseStatus.INVALID_CONDITIONALLY}_${email}` });
    }
    try {
        const response = yield CustomerApi.emailValidate(servicesEndpoint, email);
        if (response.suggestedEmail) {
            setSuggestedEmail === null || setSuggestedEmail === void 0 ? void 0 : setSuggestedEmail(response.suggestedEmail);
            return context.createError({ message: `${EmailValidationResponseStatus.SUGGESTION}_${email}` });
        }
        else if (response.status === EmailValidationResponseStatus.INVALID) {
            return context.createError({ message: `${EmailValidationResponseStatus.INVALID_CONDITIONALLY}_${email}` });
        }
        else {
            setEmailStatus === null || setEmailStatus === void 0 ? void 0 : setEmailStatus(`${EmailValidationResponseStatus.VALID}_${email}`);
            return true;
        }
    }
    catch (_a) {
        return true;
    }
});
export const validateEmail = (servicesEndpoint, skipValidation, emailStatus, setSuggestedEmail, setEmailStatus, withDebounce = true, skipValidationFor) => {
    const validate = (value, context) => __awaiter(void 0, void 0, void 0, function* () {
        if (skipValidation || (skipValidationFor && skipValidationFor === value)) {
            return true;
        }
        else if (!value) {
            return context.createError({ message: EmailValidationResponseStatus.REQUIRED });
        }
        else if (!FormValidationUtil.isValidEmailPattern(value)) {
            return context.createError({ message: EmailValidationResponseStatus.INVALID });
        }
        else {
            return yield validateEmailWithBackend(value, context, servicesEndpoint, emailStatus, setSuggestedEmail, setEmailStatus);
        }
    });
    return withDebounce ? debouncedPromise(validate, EMAIL_VALIDATION_DEBOUNCE) : validate;
};
export const validateEmailExists = (servicesEndpoint, defaultRequestParameters, errorMessages, withDebounce = true, shouldValidate = true, sendEmail = false, setIsCollapsedForm, withValidateEmail = false, skipValidation = false, emailStatus, setSuggestedEmail, setEmailStatus) => {
    const validate = (value, context) => __awaiter(void 0, void 0, void 0, function* () {
        if (!shouldValidate) {
            return true;
        }
        if (!value) {
            setIsCollapsedForm && setIsCollapsedForm(false);
            return true;
        }
        if (!FormValidationUtil.isValidEmailPattern(value)) {
            setIsCollapsedForm && setIsCollapsedForm(false);
            return context.createError({ message: errorMessages.invalidEmail });
        }
        try {
            const { accountStatusCode } = yield CustomerApi.emailExists(servicesEndpoint, defaultRequestParameters, value, sendEmail);
            if ([AuthStatusCode.NO_ACCOUNT, AuthStatusCode.UNKNOWN_ACCOUNT].includes(accountStatusCode)) {
                setIsCollapsedForm && setIsCollapsedForm(false);
                if (withValidateEmail && !skipValidation) {
                    return yield validateEmailWithBackend(value, context, servicesEndpoint, emailStatus, setSuggestedEmail, setEmailStatus);
                }
                return true;
            }
            if ([AuthStatusCode.VALID_ACCOUNT_OTHER_FASCIA, AuthStatusCode.INVALID_ACCOUNT_OTHER_FASCIA].includes(accountStatusCode) &&
                setIsCollapsedForm) {
                setIsCollapsedForm(true);
                return context.createError({
                    message: errorMessages.sendLink,
                });
            }
            setIsCollapsedForm && setIsCollapsedForm(false);
            return context.createError({
                message: errorMessages[accountStatusCode],
            });
        }
        catch (_a) {
            setIsCollapsedForm && setIsCollapsedForm(false);
            if (withValidateEmail && !skipValidation) {
                return yield validateEmailWithBackend(value, context, servicesEndpoint, emailStatus, setSuggestedEmail, setEmailStatus);
            }
            return true;
        }
    });
    return withDebounce ? debouncedPromise(validate, EMAIL_VALIDATION_DEBOUNCE) : validate;
};
